import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import InvalidForm        from 'src/components/InvalidForm'
import PaymentOptionIcon  from './PaymentOptionIcon'
import paymentMethodLabel from '../paymentMethodLabel'

// `null` is still loading; `{}` means everything was ruled out by the current
// currency/frequency, which used to render nothing at all.
const PaymentOptions = ({
  i18n, paymentOptions, paymentOption, setPaymentOption,
  show_input_labels, errors, switchedFrom,
}) => {
  if (!paymentOptions) return (
    <div className="text-center text-muted fs-4">
      <FontAwesomeIcon icon={faCircleNotch} spin />
    </div>
  )

  const options = Object.keys(paymentOptions)

  if (!options.length) return (
    <div className="mb-3">
      <div className="alert alert-warning" role="alert">
        {i18n.t('payment_methods.none')}
      </div>
    </div>
  )

  return (
    <div className="mb-3">
      {switchedFrom &&
        <div className="alert alert-warning" role="alert">
          {i18n.t('payment_methods.switched_for_currency', switchedFrom)}
        </div>
      }

      {options.length > 1 &&
        <fieldset className="mb-3">
          <legend className={show_input_labels ? 'form-label fs-6' : 'visually-hidden'}>
            {i18n.t('payment_methods.payment_method')}
          </legend>

          <div className="payment-options d-flex flex-wrap justify-content-stretch gap-2">
            {options.map(option => {
              const id = `paymentOption_${option}`

              return (
                <div key={option} className="flex-grow-1 d-grid">
                  <input
                    type="radio"
                    className="btn-check payment-option-btn"
                    id={id}
                    name="payment_option"
                    value={option}
                    checked={paymentOption == option}
                    onChange={() => setPaymentOption(option)}
                  />
                  <label
                    className="btn btn-sm btn-light btn-check-special payment-option-label"
                    htmlFor={id}
                  >
                    <PaymentOptionIcon
                      option={option}
                      paymentOptions={paymentOptions}
                    />
                    <br className="d-sm-none" />
                    {paymentMethodLabel(option, i18n, paymentOptions)}
                  </label>
                </div>
              )
            })}
          </div>
        </fieldset>
      }

      {/* Outside the branch above: a single-method panel still needs a base-error
          surface, which is where an SDK load failure lands. text-break because
          the wallet email error quotes the address, which has nowhere to wrap. */}
      <InvalidForm className="text-break">
        {/* Render stripe errors here for non-CC methods; CC renders them inline with the field. */}
        {paymentOption != 'credit_card' && errors?.stripe?.[0] || errors?.base?.[0]}
      </InvalidForm>
    </div>
  )
}

export default PaymentOptions
